/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReasonModal from "./ReasonForm";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from 'react-bootstrap/InputGroup';
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";

const Reason = () => {
  const [open, setOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [editReason, setEditReason] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue,setSearchValue] = useState();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.REASON)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.REASON.ADD;
    } else {
      param.method = Constants.MASTER.REASON.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        if (!edit) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_reason.success_message"),
            2000
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_reason.update_success_message"),
            2000
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.REASON)); // userSlice store
        setOpen(false);
      } else if (res?.payload?.errorcode === 1012) {
        setError(t("msg_master_list.msg_reason.duplicate_reason"));
        setIsError(true);
      } else {
        setError(t("msg_master_list.msg_reason.reason_add_error"));
        setIsError(true);
      }
    });
  };

  const handleDelete = () => {
    let param = {};
    param.reasonList = selectedItem;
    param.method = Constants.MASTER.REASON.DELETE;

    dispatch(deleteMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_reason.delete_success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.REASON));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_reason.invalid_input"),
          4000
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditReason(data);
    }
    setOpen(true);
  };

  const handleRowSelected = ({ selectedRows }) => {
    const selectReason = selectedRows.map((item) => item._id);
    setSelectedItem([...selectReason]);
  };

  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data._id]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return
      } else {
        setConfirmModel(true);
      }
    }
  };

  const resetAlert = () => {
    setIsAlert(false);
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  let rowsData = masterList[Constants.MASTER.REASON.name]?.data;

  const handleSearch = () => {
    const param = { 
     ...Constants.MASTER.REASON,
      value: searchValue };
    if(searchValue){
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const onSearchChange = (e) => {
    if(e.target.value){
      setSearchValue(e.target.value)  
    }else{
      dispatch(fetchMasterList(Constants.MASTER.REASON))
      setSearchValue(e.target.value)
    }
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: t("msg_master_list.msg_jobstatus.jobstatus_name"),
      selector: (row) => row.jobstatusName,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.jobstatusName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_reason.code"),
      selector: (row) => row.reasonCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reasonCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_reason.reason_name"),
      selector: (row) => row.reasonName,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.reasonName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.related_departments"),
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.reasonStatus === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.reasonStatus === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.reasonStatus
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row?.createdDate)} </p>
        </div>
      ),
      center: true,
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_master_list.msg_reason.name")}
            </h2>
            <p className="subText">{t("msg_master_list.msg_reason.details")}</p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide" >
        <Form>
                    <Form.Group>
                        <InputGroup>
                            <Form.Control
                                type="search"
                                placeholder={t("msg_common.search_placeholder")}
                                onChange={(e) => onSearchChange(e)}
                            />
                            <InputGroup.Text>
                            <i className="bi bi-search" onClick={handleSearch}></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
      />
      {open && (
        <ReasonModal
          data={editReason}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></ReasonModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_reason.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_reason.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_reason.reason_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default Reason;
